import { Controller } from 'stimulus';
import formatPrice from '../helpers/formatPrice';

class Calculator extends Controller {
  connect() {
    this.dieselPrice = parseFloat(this.data.get('diesel-price'));
    this.emission = parseInt(this.data.get('emission'), 10);

    this.calculate();
  }

  onInput() {
    this.calculate();
  }

  calculate() {
    let input = parseInt(this.litersInputTarget.value, 10);

    this.toggleHiddenUsageMessage(false);

    if (Number.isNaN(input)) {
      input = 1;
    }

    if (input > 99999) {
      this.litersInputTarget.value = 99999;
      input = 99999;

      this.toggleHiddenUsageMessage(true);
    }

    const totalPrice = this.dieselPrice * input;
    const totalEmission = this.emission * input;

    this.priceOutputTarget.textContent = formatPrice(totalPrice, 2, '');
    this.emissionOutputTarget.textContent = formatPrice(totalEmission, 0, '');
  }

  toggleHiddenUsageMessage(state) {
    this.hiddenMessageTarget.style.display = state ? 'block' : 'none';
  }
}

Calculator.targets = [
  'litersInput',
  'priceOutput',
  'emissionOutput',
  'hiddenMessage',
];

export default Calculator;
